<template>
  <div class="h-full w-full max-w-full rounded-lg flex flex-col gap-2">
    <div id="custom-popup" class="popup">
      <div class="popup-content">
        <p>Are you sure you want to continue?</p>
        <button id="confirm-button">Yes</button>
        <button id="cancel-button">No</button>
      </div>
    </div>
    <div
      class="w-full max-w-full flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema"
      ref="scrollContainer"
      >
      <AppFilterForm
        :tabela="tabela"
        :visibility="show_form_filter"
        @close="closeFilterForm"
      />
      <div class="w-full max-w-full flex gap-2">
        <AppArmazemForm
          :show="show_form"
          :disable_visibility="true"
          :update_visibility="true"
          :form_title="form_title"
          :create_btn="create_armazem_"
          :form_data="armazem_formData"
          :set_data="armazem_setData"
          @close="closeForm"
          @show_table="show_form_table"
          @create="create_armazem"
          @update="update_armazem"
          @disable="disable_armazem"
        />

        <AppTable
          :visibility="true"
          :show="show_generic_table"
          :table_data="generic_table_data"
          :table_title="generic_table_title"
          @row-clicked="select_generic_row"
          @close="close_generic_table"
          with_confirmation="true"
        />


        <AppGenericCrud
          v-if="show_crud"
          :model="crud_model"
          :title="crud_title"
          :entity_type="crud_type"
          :owner="{ type: 'armazem', id: armazem.id }"
          :with_address="crud_with_address"
          @close="close_crud"
        />

        <AppAddressMap
          v-if="show_address"
          :initialAddress="armazem_endereco"
          @close="close_address()"
          @save="update_address"
        />

        <AppMultiTable
          v-if="show_multitable"
          title="Adicionar Utilizadores"
          :table1="{
            title: 'Utilizadores do Armazem',
            type: 'utilizador',
            owner: {
              id: armazem.id,
              nome: 'armazem_id',
            },
            rotas: {
              select_all_url: `${baseURl}/api/v1/armazem/${armazem.id}/?utilizadores_only=True/`,
              create_url: `${baseURl}/api/v1/utilizador/registrar/`,
              select_url: `${baseURl}/api/v1/utilizador/`,
              update_url: `${baseURl}/api/v1/utilizador/editar`,
              delete_url: `${baseURl}/api/v1/utilizador/eliminar`,
            },
          }"
          :table2="{
            title: 'Utilizadores',
            type: 'utilizador',
            rotas: {
              select_all_url: `${baseURl}/api/v1/utilizador/s/funcionario_escritorio/`,
              create_url: '',
              select_url: '',
              update_url: '',
              delete_url: '',
            },
          }"
          @close="close_multiTable()"
        />

        <armazemEstoqueView
          v-if="show_armazem_stock"
          :armazem-id="armazem.id"
          @close="close_armazem_stock"
        />
        <TransferirArtigoView
          v-if="show_armazem_transf_artigo"
          :armazem-id="armazem.id"
          :mostrarIconesArmazem="false"
          @close="close_armazem_transf_artigo"
        />
        <TransferirOSView
          v-if="show_armazem_transf_OS"
          :armazem-id="armazem.id"
          :mostrarIconesArmazem="false"
          @close="close_armazem_transf_OS"
        />

        <AppArtigoCreateForm
          v-if="show_novo_artigo"
          :armazem-id="armazem.id"
          :form_data="artigo_formData"
          :set_data="artigo_setData"
          :show="show_novo_artigo"
          :form_title="'Novo Artigo'"
          :create_btn="true"
          :mostrarIconesArmazem="false"
          @close="close_novo_artigo"
          @create="create_artigo"
        />
        <MovimentosFechados
          class="w-full"
          v-if="showMovimentosFechados"
          :armazemId="armazem?.id"
          @close="showMovimentosFechados = false"
        />

      </div>
      <div class="w-full">
        <GenericDataTable
          v-if="validPermission('A0006')"
          ref="dataTableRef"
          @row-click="select_armazem"
          @boolean-toggle="handleBooleanToggle"
          :api-url="`${baseURl}/api/v1/armazem/pagination/`"
          :useServerSide="true"
          :columns="armazemColumns"
          :editable-columns="['reorcamentar']"
          :preserve-api-order="true"
          :initial-params="currentFilters"
          :show_export="true"
          :show_close_btn="false"
          table_title="Armazéns"
        >
          <template #left-actions>
            <!-- <button
                    class="action-btn filter-btn"
                    @click="showFilter = !showFilter"
                    title="Filtros"
                    ><i class="fa-solid fa-filter"></i></button
                > -->
            <button
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_armazem' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import AppAddressMap from "@/components/addressMap.vue";
import AppForm from "@/components/form.vue";
import AppArmazemForm from "@/components/forms/armazem/armazemForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppActionCard from "@/components/actionCard.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import AppFilterForm from "@/components/filter/filterForm.vue";
import AppGenericCrud from "@/components/genericCRUD.vue";
import AppMultiTable from "@/components/multiTable.vue";
import armazemEstoqueView from "@/components/forms/armazem/armazemEstoque.vue";
import TransferirArtigoView from "@/components/forms/artigo/artigoTransfer.vue";
import AppArtigoCreateForm from "@/components/forms/artigo/artigoForm.vue";

import TransferirOSView from "@/components/forms/artigo/ArtigoTransferOrdem.vue";
import permissionMixin from "@/permissionMixin.js";
import { toast } from "vue3-toastify";
import { id as loggedID } from "@/extraData";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import EquipamentosDoArtigo from "@/components/forms/equipamento/EquipamentosDoArtigo.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import MovimentosFechados from "@/components/stock/movimento/MovimentosFechados.vue";

export default {
  mixins: [permissionMixin],
  name: "apparmazens",
  components: {
    AppArtigoCreateForm,
    TransferirOSView,
    AppTablePagination,
    Dialog,
    EquipamentosDoArtigo,
    TransferirArtigoView,
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppActionCard,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppArmazemForm,
    AppButton,
    AppFilterForm,
    AppGenericCrud,
    AppAddressMap,
    AppMultiTable,
    armazemEstoqueView,
    GenericDataTable,
    MovimentosFechados,
  },
  data() {
    return {
      showMovimentosFechados: false,
      show_novo_artigo: false,
      create_artigo_: false,
      artigo_formData: {},
      artigo_setData: {},
      selected_armazem: {},
      baseURl: process.env.VUE_APP_URL_BASE,
      dialogProps: {
        entity: ["historico"],
        sideBar: true,
        multi: false,
        queryParams: {},
        specialQuery: {},
      },
      refresh: false,
      showDialog: false,
      selectedHistorico: {},
      selectedArtigoId: null,
      historico: [],
      armazens: [],
      armazem: {},
      armazem_tipos: [],
      armazem_endereco: {},
      utilizadores: [],
      transferencias: [],
      inventarios: [],
      devolucoes: [],
      recolhas: [],
      entregas: [],
      zonas: [],
      generic_table_data: [],
      generic_table_title: "Generic Table",
      current_table: "none",
      show_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,
      show_crud: false,
      crud_with_address: false,
      show_address: false,
      show_multitable: false,
      show_armazem_stock: false,
      show_armazem_transf_artigo: false,
      show_armazem_transf_OS: false,
      form_title: "No Title",
      create_armazem_: false,

      armazem_formData: {},
      armazem_setData: {},
      crud_model: {},
      crud_set_data: {},
      crud_title: "",
      crud_type: "",
      contacto_tipos: [],
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "armazem",
      table_title: "Armazens",
      armazemColumns: [
        {
          key: "nome",
          label: "Nome",
          sortable: true,
          type: "string",
          maxWidth: 220,
        },
        {
          key: "movimentos",
          label: "Movimentos",
          sortable: true,
          type: "badge",
          maxWidth: 100,
        },
        {
          key: "armazem",
          label: "Tipo",
          sortable: true,
          type: "string",
          maxWidth: 100,
        },
        {
          key: "endereco",
          label: "Endereço",
          sortable: true,
          type: "string",
          maxWidth: 100,
        },
        {
          key: "morada",
          label: "Morada",
          sortable: true,
          type: "string",
          maxWidth: 100,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          type: "string",
          maxWidth: 100,
        },
      ],
    };
  },

  async created() {
    // this.get_armazens()
    this.getTypes();
    this.setarmazemForm(null);
    this.setArtigoForm(null);

    // Handle armazem_id from URL params
    if (this.$route.params.armazem_id) {
      await this.select_armazem_by_id(this.$route.params.armazem_id);
    }
  },
  methods: {
    create_artigo(formData) {
      const payload = {
        nome: formData.nome || "Artigo qualquer",
        descricao: formData.descricao || "Sem descrição",

        tpArtigo_id: formData?.tipo_artigo?.id ?? null,
        equipamento_id: formData?.equipamento?.id ?? null,
        precoCompra: formData?.precoCompra ?? 0,
        precoVenda: formData?.precoVenda ?? 0,

        quantidade: formData.quantidade,

        armazem_id: formData?.armazem?.id ?? null,
      };

      axios
        .post(`${this.baseURl}/api/v1/artigo/quantity/registrar/`, payload)
        .then((res) => {
          console.log("Artigo criado com sucesso:", res.data);

          toast.success("Artigo criada com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });

          this.artigo_formData = {
            quantidade: 1,
            precoCompra: 0,
            precoVenda: 0,
          };
          this.artigo_setData = {
            armazem: { id: 0, nome: "N/A" },
            equipamento: { id: 0, nome: "N/A" },
            tipo_artigo: { id: 0, nome: "N/A" },
          };

          this.close_novo_artigo();
        })
        .catch((err) => {
          console.error("Erro ao criar Artigo:", err.response?.data);
        });
    },

    setArtigoForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.artigo_formData = {
        id: data && data.id ? data.id : 0,
        numero: data && data.numeroSerie ? data.numeroSerie : "",
        quantidade: data && data.quantidade ? data.quantidade : 1,
        dataFabrico: data && data.dataFabrico ? data.dataFabrico : "2025-01-01",
      };

      this.artigo_setData = {
        armazem:
          data && data.armazem && !isEmptyObject(data?.armazem)
            ? data.armazem
            : { id: 0, nome: "N/A" },
        equipamento:
          data && data.equipamento && !isEmptyObject(data?.equipamento)
            ? data.equipamento
            : { id: 0, nome: "N/A" },
        tipo_artigo:
          data && data.tpArtigo && !isEmptyObject(data?.tpArtigo)
            ? data.tpArtigo
            : { id: 0, nome: "N/A" },
        cliente:
          data && data.fornecedor && !isEmptyObject(data?.fornecedor)
            ? data.fornecedor
            : { id: 0, nome: "N/A" },
        sub_cliente:
          data && data.sub_cliente && !isEmptyObject(data?.sub_cliente)
            ? data.sub_cliente
            : { id: 0, nome: "N/A" },
        local:
          data && data.local && !isEmptyObject(data?.local)
            ? data.local
            : { id: 0, nome: "N/A" },
        servico:
          data && data.servico && !isEmptyObject(data?.servico)
            ? data.servico
            : { id: 0, nome: "N/A" },
      };
    },
    async getHistoricoArmazem() {
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/historico/?campo=tema&valor=Armazem&exact=true`,
        );
        const historicoData = response.data.data;

        // Buscar usuários e mapear IDs para nomes
        const utilizadores = await axios.get(
          `${this.baseURl}/api/v1/utilizador/`,
        );
        const usersMap = {};
        utilizadores.data.data.forEach((user) => {
          usersMap[user.id] = user.user;
        });

        // Mapear objetos do armazém
        const objetosMap = {};
        const promessas = historicoData.map(async (item) => {
          let nomeObjeto = "Desconhecido";
          try {
            const res = await axios.get(
              `${this.baseURl}/api/v1/armazem/${item.objeto_id}/`,
            );
            nomeObjeto = res.data.data.nome || "Desconhecido";
          } catch (error) {
            console.error(
              `Erro ao buscar nome do Armazém ID: ${item.objeto_id}`,
              error,
            );
          }
          objetosMap[item.objeto_id] = nomeObjeto;
        });

        // Aguarde todas as requisições terminarem
        await Promise.all(promessas);

        // Processar histórico
        this.historico = historicoData.map((item) => ({
          id: item.id,
          usuario: usersMap[item.utilizador_id] || "Desconhecido",
          acao: item.acao,
          objeto: objetosMap[item.objeto_id] || "Objeto Desconhecido",
          data: this.formatarData(item.data),
        }));

        // Atualiza o Dialog para buscar histórico corretamente
        this.dialogProps.entity = ["historico"];
        this.dialogProps.queryParams = {};
        this.dialogProps.specialQuery = {};

        this.showDialog = true;
      } catch (error) {
        console.error("Erro ao buscar histórico do armazém:", error);
        this.historico = [];
        this.showDialog = true;
      }
    },
    formatarData(dataString) {
      if (!dataString) return "Data inválida";

      let data = new Date(dataString);
      if (isNaN(data.getTime())) {
        let dataCorrigida = dataString.replace("Z", "");
        data = new Date(dataCorrigida);
        if (isNaN(data.getTime())) return "Data inválida";
      }

      return data.toLocaleString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    openEquipamentosDialog(artigo) {
      this.selectedArtigoId = artigo.id;
      this.showDialog = true;
    },
    openHistoricoDialog(historico) {
      this.selectedHistorico = historico;
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    async get_stock_data() {
      try {
        const res = await axios.get(`${this.baseURl}/api/v1/estoque/`);
        this.generic_table_data = res.data;
      } catch (error) {
        console.error("Erro ao buscar dados do stock:", error);
      }
    },
    async getEstoque() {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      const estoques = await this.select_all(
        `${this.baseURl}/api/v1/estoque/?armazem_id=${this.armazem_id}`,
      );
      this.table_title = "Stock de Equipamentos";
      this.table_data = estoques;
      this.estoques = estoques?.sort((a, b) => a.id - b.id);
      if (this.model_type == "estoque") {
        this.upTable_data = [...this.estoques];
      } else {
        this.upTable_data = [];
      }
    },
    async getArmazemArtigos(armazem_id) {
      if (!armazem_id) {
        console.error("Armazem ID não definido");
        this.generic_table_data = [];
        this.generic_table_title = "Nenhum armazém selecionado";
        this.show_generic_table = true;
        toast.error("ID do armazém não definido", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        return;
      }
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/armazem/${armazem_id}/artigos/`,
        );
        const artigos = response.data;
        if (artigos.length === 0) {
          this.generic_table_data = [];
          this.generic_table_title = `Nenhum artigo encontrado no armazém ${armazem_id}`;
        } else {
          this.generic_table_data = artigos;
          this.generic_table_title = `Artigos no Armazém ${armazem_id}`;
        }
        this.show_generic_table = true;
      } catch (error) {
        console.error("Nenhum artigo encontrado neste armazém:", error);
        this.generic_table_data = [];
        this.generic_table_title = `Armazém ${armazem_id} Vazio`;
        this.show_generic_table = true;
      }
    },
    async get_armazens() {
      // const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
      // const res = await this.select_all(`${this.baseURl}/api/v1/armazem/`);
      // let modified_armazens = res.map(value => ({
      //     id: value.id,
      //     nome: value.nome,
      //     descricao: value.descricao || 'N/A',
      //     zona: (value.zona && value.zona.nome) ? value.zona.nome : "N/A",
      //     tipo: (value.tipo && value.tipo.nome) ? value.tipo.nome : "N/A",
      //     endereco:(value?.endereco?.pais && !isEmptyObject(value?.endereco))? value.endereco.pais:'N/A',
      //     status: value.status? value.status:'',
      // }));
      // this.armazens = modified_armazens?.sort((a, b) => a.id - b.id);
      this.refresh = true;
    },
    async create_armazem(data) {
      let create_data = this.setData(data);
      const res = await this.create(
        create_data,
        `${this.baseURl}/api/v1/armazem/registrar/`,
      );
      if (res) {
        data.id = res.id;
        toast.success("armazem criada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.create_update_endereco("create", res);
        await this.get_armazens();
        await this.getTypes();
        await this.upload_img(data);
        this.closeForm();
        this.show_table = true;
        this.$refs.dataTableRef.refresh();
      } else {
        toast.error("Erro ao criar armazem", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    async select_armazem(data) {
      this.$nextTick(() => {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
      });
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.closeAll();
      this.create_armazem_ = false;
      this.form_title = "Informação Do Armazem";
      const armazem = await this.select(
        `${this.baseURl}/api/v1/armazem/${data.id}/`,
      );
      this.armazem = JSON.parse(JSON.stringify(armazem));
      if (armazem) {
        this.armazem_endereco = JSON.parse(JSON.stringify(armazem.endereco));
        if (isEmptyObject(this.armazem_endereco)) {
          this.armazem_endereco.id = 0;
        }
        this.setarmazemForm(armazem);
        await this.get_imagem(armazem.id);
        this.show_form = true;
      }
    },
    async select_armazem_by_id(armazem_id) {
      try {
        const armazem = await this.select(
          `${this.baseURl}/api/v1/armazem/${armazem_id}/`,
        );

        if (armazem) {
          // Call the existing select_armazem method with the fetched data
          await this.select_armazem({ id: armazem.id });
        } else {
          console.error(`Armazém with ID ${armazem_id} not found`);
          toast.error(`Armazém ${armazem_id} não encontrado`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching armazem by ID:", error);
        toast.error(`Erro ao carregar armazém ${armazem_id}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    },
    async update_armazem(data) {
      let update_data = this.setData(data);
      const res = await this.update(
        `${this.baseURl}/api/v1/armazem/editar/${data.id}/`,
        update_data,
      );
      if (res) {
        toast.success("Armazem atualizado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.create_update_endereco("update", res);
        await this.get_armazens();
        await this.getTypes();
        await this.upload_img(data);
        this.closeForm();
        this.show_table = true;
        this.$refs.dataTableRef.refresh();
      } else {
        toast.error("Erro ao atualizar armazem", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    async remove_armazem(data) {
      const res = await this.remove(
        `${this.baseURl}/api/v1/armazem/eliminar/${data.id}/`,
      );
      if (res) {
        this.refresh = !this.refresh;
        toast.success("Armazem eliminado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_armazens();
        this.closeForm();
      }
    },
    triggerAction(action) {
        this.closeAll();
      if (action.action === "create_armazem") {
        this.create_armazem_ = true;
        this.form_title = "Criar armazem";
        this.setarmazemForm(null);
        this.show_form = true;
      }
      if (action.action === "transfer_ordemServico") {
        this.show_transfer_OS = true;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },
    closeForm() {
      this.show_form = false;
      this.closeAll();
    },
    close_table() {
      this.show_table = false;
    },
    close_generic_table() {
      if (this.show_generic_table) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_generic_table = false;
    },
    close_crud() {
      if (this.show_crud) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_crud = false;
    },
    close_address() {
      if (this.show_address) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_address = false;
    },
    close_multiTable() {
      if (this.show_multitable) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_multitable = false;
    },
    close_armazem_stock() {
      if (this.show_armazem_stock) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_armazem_stock = false;
    },
    close_armazem_transf_artigo() {
      if (this.show_armazem_transf_artigo) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_armazem_transf_artigo = false;
    },
    close_armazem_transf_OS() {
      if (this.show_armazem_transf_OS) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_armazem_transf_OS = false;
    },
    close_novo_artigo() {
      if (this.show_novo_artigo) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_novo_artigo = false;
    },
    close_movimentos_fechados() {
      if (this.showMovimentosFechados) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.showMovimentosFechados = false;
    },
    closeAll() {
      this.close_generic_table();
      this.close_crud();
      this.close_address();
      this.close_multiTable();
      this.close_armazem_stock();
      this.close_armazem_transf_artigo();
      this.close_novo_artigo();
      this.clear_armazem_endereco();
      this.close_movimentos_fechados();
      this.close_armazem_transf_OS();
    },
    close_action_card() {
      this.show_action_card = false;
    },
    closeFilterForm() {
      this.show_form_filter = false;
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async getTypes() {
      const tipos = await this.select_all(`${this.baseURl}/api/v1/tparmazem/`);
      const utilizadores = await this.select_all(
        `${this.baseURl}/api/v1/utilizador/s/funcionario_escritorio/`,
      );
      const contato_tipos = await this.select_all(
        `${this.baseURl}/api/v1/tpcontacto/`,
      );
      const zonas = await this.select_all(`${this.baseURl}/api/v1/tpzona/`);
      const filteredUtilizadores = utilizadores.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).filter(([key]) => ["id", "user"].includes(key)),
        ),
      );
      this.zonas = zonas
        ?.filter((z) => z?.status === "ativo")
        .sort((a, b) => a.id - b.id);
      this.contacto_tipos = contato_tipos.sort((a, b) => a.id - b.id);
      this.armazem_tipos = tipos?.sort((a, b) => a.id - b.id);
      this.utilizadores = filteredUtilizadores?.sort((a, b) => a.id - b.id);
      this.GPS = [];
    },
    setarmazemForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.armazem_formData = {
        id: data && data.id ? data.id : 0,
        armazem: data && data.nome ? data.nome : "",
        foto: require("@/assets/warehouse.svg"),
        descricao: data && data.descricao ? data.descricao : "",
        movimentos: data && data.movimentos ? data.movimentos : 0,
        status: data && data.status ? data.status : "",
      };
      this.armazem_setData = {
        tipo_armazem:
          data && data.tipo && !isEmptyObject(data?.tipo)
            ? data.tipo
            : { id: 0, nome: "Não Atribuido" },
        endereco:
          data && data.endereco && !isEmptyObject(data?.endereco)
            ? data.endereco
            : { id: 0, pais: "Não Atribuido" },
        zona:
          data && data.zona && !isEmptyObject(data?.zona)
            ? data.zona
            : { id: 0, nome: "Não Atribuido" },
      };
    },
    setData(data) {
      let prepared_data = {
        nome: data.armazem || "",
        descricao: data.descricao || "",
        endereco_id: data?.endereco?.id || 0,
        tpArmazem_id: data?.tipo_armazem?.id || 0,
        tpZona_id: data?.zona?.id || 0,
      };
      return prepared_data;
    },
    show_form_table(data) {
      this.closeAll();
      if (data === "contacto") {
        (this.crud_model = {
          id: 0,
          nome: "",
          email: "",
          telefone: "",
          telemovel: "",
          descricao: "",
          tipo: 0,
          tipos: this.contacto_tipos,
        }),
          (this.crud_title = "Contactos");
        this.crud_type = "contacto";
        this.crud_with_address = false;
        this.show_crud = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "utilizador") {
        this.show_multitable = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "mapa") {
        this.show_address = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "stock") {
        this.show_armazem_stock = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "Transferir_Artigos") {
        this.show_armazem_transf_artigo = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "Transferir_OS") {
        this.show_armazem_transf_OS = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "novo_artigo") {
        this.show_novo_artigo = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "Movimentos_Pendentes") {
        this.showMovimentosFechados = true;
        document.getElementById("right_form").style.display = "none";
      }

      const tableMappings = {
        tipo: { data: this.armazem_tipos, title: "Tipos" },
        zona: { data: this.zonas, title: "Zonas" },
        armazem: { data: this.armazens, title: "Armazens" },
        GPS: { data: this.armazens, title: "GPS" },
      };
      const mapping = tableMappings[data];
      if (mapping) {
        this.current_table = data;
        this.generic_table_data = mapping.data;
        this.generic_table_title = mapping.title;
        this.show_generic_table = true;
        document.getElementById("right_form").style.display = "none";
      }
    },
    select_generic_row(data) {
      if (this.current_table == "tipo") {
        this.armazem_setData.tipo_armazem = data;
      } else if (this.current_table == "zona") {
        this.armazem_setData.zona = data;
      } else if (this.current_table == "utilizador") {
        this.armazem_setData.utilizador = data;
      }
      this.close_generic_table();
    },
    async disable_armazem(data) {
      let update_data = {
        nome: data.armazem,
        status: data.status == "ativo" ? "desativado" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/armazem/editar/${data.id}/`,
        update_data,
      );
      if (res) {
        const message = data.status == "ativo" ? "desativado" : "ativado";
        this.armazem_formData.status = update_data.status;
        toast.success(`Armazem ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_armazens();
      } else {
        const message = data.status == "ativo" ? "desativar" : "ativar";
        toast.error(`Erro ao ${message} Armazem`, {
          autoClose: 1000,
        });
      }
    },

    update_address(data) {
      this.armazem_setData.endereco = data;
      this.armazem_endereco = JSON.parse(JSON.stringify(data));
      this.close_address();
    },
    clear_armazem_endereco() {
      this.armazem_endereco = {
        pais: "",
        morada: "",
        codigoPostal: "",
        freguesia: "",
        localidade: "",
        latitude: "",
        longitude: "",
        concelho: "",
        distrito: "",
      };
    },
    async create_update_endereco(action, armazem) {
      if (action == "create") {
        delete this.armazem_endereco.id;
        const res = await this.create(
          this.armazem_endereco,
          `${this.baseURl}/api/v1/endereco/registrar/`,
        );
        if (res) {
          const updated_armazem = await this.update(
            `${this.baseURl}/api/v1/armazem/editar/${armazem.id}/`,
            { nome: armazem.nome, endereco_id: res.id },
          );
        } else {
          toast.error("Erro ao criar endereço", {
            autoClose: 1000,
          });
        }
      } else if (action == "update") {
        if (this.armazem_endereco.id == 0) {
          const res = await this.create(
            this.armazem_endereco,
            `${this.baseURl}/api/v1/endereco/registrar/`,
          );
          if (res) {
            const updated_armazem = await this.update(
              `${this.baseURl}/api/v1/armazem/editar/${armazem.id}/`,
              { nome: armazem.nome, endereco_id: res.id },
            );
          } else {
            toast.error("Erro ao Criar endereço", {
              autoClose: 1000,
            });
          }
        } else {
          const res = await this.update(
            `${this.baseURl}/api/v1/endereco/editar/${this.armazem_endereco.id}/`,
            this.armazem_endereco,
          );
          if (res) {
          } else {
            toast.error("Erro ao atualizar endereço", {
              autoClose: 1000,
            });
          }
        }
      }
    },
    async upload_img(formData) {
      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/armazem/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },
    async get_imagem(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/armazem/foto/${id}/`,
          { responseType: "blob" },
        );
        if (response.status != 200) return;
        this.armazem_formData.foto = URL.createObjectURL(
          new Blob([response.data]),
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    // Watch for route changes to handle dynamic armazem_id changes
    "$route.params.armazem_id": {
      async handler(newArmazemId, oldArmazemId) {
        if (newArmazemId && newArmazemId !== oldArmazemId) {
          await this.select_armazem_by_id(newArmazemId);
        }
      },
      immediate: false, // Don't trigger on initial load since created() handles it
    },
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData,
        );
        this.armazens = response.data.data;
      } else {
        this.get_armazens();
        this.table_title = "Armazens";
        this.show_table = true;
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}
.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.popup-content {
  text-align: center;
}
.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}
.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}
.btn:hover {
  background-color: #c67700;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
